<template>
  <van-pull-refresh v-model="refreshing"
                    @refresh="onRefresh">
    <van-list
        v-if="!finished || items && items.length > 0"
        v-model="loading"
        :finished="refreshing || finished"
        finished-text="没有更多了"
        @load="onLoad"
        :style="{minHeight: minHeight}">
      <slot :items="items"></slot>
    </van-list>
    <template v-else>
      <div
          class="empty-page"
          :style="{minHeight: minHeight}"
      >
        <div>
          <van-image
              width="150"
              height="150"
              :src="emptyLogo"
          />
        </div>
        <div style="margin-top: 20px; color: #666666;">
          <span>{{ emptyText }}</span>
        </div>
        <div :style="{height: logoPaddingBottom}">
        </div>
      </div>
    </template>
  </van-pull-refresh>
</template>

<script>
import {PullRefresh, List, Image} from 'vant';
import defaultPicture from "@/assets/myElectronicPass/defaultPicture.png";

export default {
  name: "VgPullRefreshList",
  components: {
    'van-pull-refresh': PullRefresh,
    'van-list': List,
    'van-image': Image
  },
  props: {
    onLoadPage: {
      type: Function,
      required: true,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    minHeight: {
      type: String,
      default: '100vh',
    },
    logoPaddingBottom: {
      type: String,
      default: '0',
    },
    emptyText: {
      type: String,
      default: '暂无记录'
    },
    value: {
      type: Array,
      default() {
        return []
      }
    }
  },
  created() {
    this.items = this.value
  },
  data() {
    return {
      items: [],
      refreshing: false,
      loading: false,
      finished: false,
      nextPage: 0,
      emptyLogo: defaultPicture
    };
  },
  methods: {
    onRefresh() {
      this.finished = false;
      // this.loading = true;
      this.nextPage = 0;
      this.refreshing = true;
      this.onLoad()
    },
    onLoad() {
      this.onLoadPage({page: this.nextPage, size: this.pageSize})
          .then(({models, finished}) => {
            if (this.refreshing) {
              this.items = models;
              this.refreshing = false;
            } else {
              this.items = this.items.concat(models);
            }
            this.loading = false;
            this.finished = finished;
            this.nextPage++;
            this.$emit('loaded', this.items);
          })
          .catch(() => {
            if (this.refreshing) {
              this.items = [];
              this.refreshing = false;
            } else {
              this.items = this.items.concat([]);
            }
            this.loading = false;
            this.finished = true;
            this.$emit('loaded', this.items);
            // Toast.fail('加载失败，请重试');
          });
    },
  },
}
</script>

<style scoped>
.empty-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
